export enum AddressEntryMinLengths {
  CONTACT_STATE = 2,
  CONTACT_PHONE_NUMBER = 7,
  CONTACT_FAX_NUMBER = 7,
}
